import { RefObject } from "react";
import { twMerge } from "tailwind-merge";
import { Type } from "@themes/pollinator/ui/Type";
import formatDateToString from "@core/utils/formatDateToString";
import { ProgramPhase } from "@core/features/program";

export type Props = {
  selectedPhase: ProgramPhase;
  phases: ProgramPhase[];
  setSelectedPhase: (phase: ProgramPhase) => void;
  timelineRef: RefObject<HTMLDivElement>;
};

export function ProgramPhasesTimeline({
  selectedPhase,
  phases,
  setSelectedPhase,
  timelineRef,
}: Props) {
  return (
    <div className="border border-brand-800 overflow-hidden rounded-lg w-full">
      <div
        ref={timelineRef}
        className="flex items-center w-full overflow-x-auto rounded-lg gap-1 scrollbar-hide"
      >
        {phases.map((p, i) => (
          <button
            key={p.id}
            id={`timeline-icon-${i}`}
            className={twMerge(
              `flex flex-col items-center justify-center
                cursor-pointer
                h-14
                min-w-[min(15rem,50vw)]
                px-4
                rounded-lg
                border
                border-transparent
                text-brand-700 
                hover:bg-brand-100
                hover:text-brand-800
                hover:border-brand-800
                `,
              selectedPhase.id === p.id &&
                "bg-brand-200 text-brand-800 border-brand-800"
            )}
            onClick={() => setSelectedPhase(p)}
            title={p.name}
            aria-label={p.name}
            aria-current={selectedPhase.id === p.id || undefined}
          >
            <div className="text-center w-full">
              <Type
                variant="h6"
                className={twMerge(
                  "whitespace-nowrap",
                  p.status === "completed" && "text-brand-400"
                )}
              >
                {p.name}
              </Type>
              <div className="flex justify-center">
                {p.status === "completed" && (
                  <Type
                    variant="small"
                    className={twMerge(
                      p.status === "completed" && "text-brand-400"
                    )}
                  >
                    Completed
                  </Type>
                )}

                {p.status === "active" && (
                  <Type variant="small">Current Phase</Type>
                )}

                {p.status === "upcoming" && p.start_date_time_display && (
                  <Type variant="small" className="whitespace-nowrap">
                    {formatDateToString(p.start_date_time_display, true)}
                  </Type>
                )}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ProgramPhasesTimeline;

